import {API} from 'aws-amplify'
import store from '../redux/store';
export default class WriteDB{
    addForm(formName){
        return new Promise((resolve,reject) =>{
            var data = {
                link:store.getState().exam.link,
                password: store.getState().exam.password,
                formName:formName,
                writeType: 'AddForm'
            }

            const init = {
                headers: {'Content-type': 'application/json'},
                body:data
            }

            API.put('Patient','/write',init).then(writeResponse =>{
                console.log(writeResponse)
                resolve();
            }) 
        })
    }

    writeTriage(){
        return new Promise((resolve,reject)=>{
            const data = {
                'link': store.getState().exam.link,
                'password': store.getState().exam.password,
                'triageScore': store.getState().exam.triageScore,
                'writeType': 'WriteTriage'
            }
    
            const init = {
                headers: {'Content-type': 'application/json'},
                body: data,
            }
    
            API.put('Patient','/write',init).then(response =>{
                console.log(response)
                resolve(response)
            });
        })
    }

    writePatientDOB(patientDOB){
        return new Promise((resolve,reject)=>{
            const data = {
                link: store.getState().exam.link,
                password: store.getState().exam.password,
                patientDOB: patientDOB,
                writeType: 'WriteDOB'
            }
    
            const init = {
                headers: {'Content-type': 'application/json'},
                body: data,
            }
    
            API.put('Patient','/write',init).then(response =>{
                resolve(response)
            });
        })
    }

    writeTempTriage(){
        return new Promise((resolve,reject)=>{
            const data = {
                link: store.getState().exam.link,
                password: store.getState().exam.password,
                triageScore:store.getState().exam.triageScore,
                writeType: 'WriteTempTriage'
            }
    
            const init = {
                headers: {'Content-type': 'application/json'},
                body: data,
            }
    
            API.put('Patient','/write',init).then(response =>{
                resolve(response)
            });
        })
    }

    sendData(formName,formData){
        return new Promise((resolve, reject) =>{
            delete formData.submitText;
            delete formData.showCollapsed;
            delete formData.showAlert;
            const data = {
                link: store.getState().exam.link,
                password: store.getState().exam.password,
                formN: formName,
                formData: formData,
                examType: store.getState().exam.examType,
                writeType: 'WriteForm'
            }
    
            const init = {
                headers: {'Content-type': 'application/json'},
                body: data,
            }
    
            API.put('Patient','/write',init).then(response =>{
                resolve(true);
            }).catch(error =>{
                resolve(false)
            });
        })
    }

    writeCompletedForm(formName){
        return new Promise((resolve, reject) =>{
            const data = {
                link: store.getState().exam.link,
                password: store.getState().exam.password,
                formName: formName,
                writeType: 'WriteCompletedForm'
            }
    
            const init = {
                headers: {'Content-type': 'application/json'},
                body: data,
            }
    
            API.put('Patient','/write',init).then(response =>{
                resolve(true);
            }).catch(error =>{
                resolve(false)
            });
        })
    }

    deleteLink(){
        return new Promise((resolve,reject)=>{
            const data = {
                link: store.getState().exam.link,
                writeType: 'DeleteLink'
            }

            const init = {
                headers: {'Content-type': 'application/json'},
                body: data,
            }
          
            API.put('Patient','/write',init).then(response =>{
                resolve(response)
            });
        })
    }
}
